import { ImageOff, Share2 } from 'lucide-react'
import type { Product } from '@/types'
import { currency } from '@/lib/format'

export function ProductCard({ product, onShare }: { product: Product; onShare: (p: Product) => void }) {
  return (
    <div className="card flex flex-col overflow-hidden">
      <div className="relative aspect-square bg-surface-sunken">
        {product.imageUrl ? (
          <img
            src={product.imageUrl}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-ink-faint">
            <ImageOff className="h-8 w-8" />
          </div>
        )}

        {product.hasDiscount && product.discountPercent ? (
          <span className="absolute left-2 top-2 rounded-md bg-danger px-1.5 py-0.5 text-[11px] font-bold text-white">
            -{product.discountPercent}%
          </span>
        ) : null}

        {product.category && (
          <span className="badge absolute right-2 top-2 bg-surface/90">{product.category}</span>
        )}
      </div>

      <div className="flex flex-1 flex-col gap-1 p-3">
        <p className="line-clamp-2 min-h-[2.5rem] text-sm font-medium leading-snug text-ink">
          {product.name}
        </p>

        <div className="flex flex-wrap items-baseline gap-x-2">
          <span className="text-base font-bold accent-text">{currency(product.price)}</span>
          {product.listPrice ? (
            <span className="text-xs text-ink-faint line-through">{currency(product.listPrice)}</span>
          ) : null}
        </div>

        <p className="text-[11px] text-ink-muted">Stock: {product.stock}</p>

        <button
          data-tour="share"
          className="btn-primary btn-block mt-1.5 py-2 text-xs"
          onClick={() => onShare(product)}
        >
          <Share2 className="h-3.5 w-3.5" />
          Compartir
        </button>
      </div>
    </div>
  )
}
